export const GET_OUTING_PUNCH_SETTING_CALL = 'GET_OUTING_PUNCH_SETTING_CALL';
export const GET_OUTING_PUNCH_SETTING_DONE = 'GET_OUTING_PUNCH_SETTING_DONE';
export const GET_OUTING_PUNCH_SETTING_FAIL = 'GET_OUTING_PUNCH_SETTING_FAIL';

export const GET_OUTING_PUNCH_CALL = 'GET_OUTING_PUNCH_CALL';
export const GET_OUTING_PUNCH_DONE = 'GET_OUTING_PUNCH_DONE';
export const GET_OUTING_PUNCH_FAIL = 'GET_OUTING_PUNCH_FAIL';

export const POST_OUTING_PUNCH_CALL = 'POST_OUTING_PUNCH_CALL';
export const POST_OUTING_PUNCH_DONE = 'POST_OUTING_PUNCH_DONE';
export const POST_OUTING_PUNCH_FAIL = 'POST_OUTING_PUNCH_FAIL';

export const DELETE_OUTING_PUNCH_CALL = 'DELETE_OUTING_PUNCH_CALL';
export const DELETE_OUTING_PUNCH_DONE = 'DELETE_OUTING_PUNCH_DONE';
export const DELETE_OUTING_PUNCH_FAIL = 'DELETE_OUTING_PUNCH_FAIL';

export const GET_OUTING_PUNCH_ATTACHMENT_CALL = 'GET_OUTING_PUNCH_ATTACHMENT_CALL';
export const GET_OUTING_PUNCH_ATTACHMENT_DONE = 'GET_OUTING_PUNCH_ATTACHMENT_DONE';
export const GET_OUTING_PUNCH_ATTACHMENT_FAIL = 'GET_OUTING_PUNCH_ATTACHMENT_FAIL';

export const DELETE_OUTING_PUNCH_ATTACHMENTS_CALL = 'DELETE_OUTING_PUNCH_ATTACHMENTS_CALL';
export const DELETE_OUTING_PUNCH_ATTACHMENTS_DONE = 'DELETE_OUTING_PUNCH_ATTACHMENTS_DONE';
export const DELETE_OUTING_PUNCH_ATTACHMENTS_FAIL = 'DELETE_OUTING_PUNCH_ATTACHMENTS_FAIL';

export const POST_OUTING_PUNCH_ATTACHMENTS_CALL = 'POST_OUTING_PUNCH_ATTACHMENTS_CALL';
export const POST_OUTING_PUNCH_ATTACHMENTS_DONE = 'POST_OUTING_PUNCH_ATTACHMENTS_DONE';
export const POST_OUTING_PUNCH_ATTACHMENTS_FAIL = 'POST_OUTING_PUNCH_ATTACHMENTS_FAIL';
